module.exports = __webpack_public_path__ + "img/moishop_portfolio_3_mob.1ba14640.png";